type FullNameSource = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
};

const toFullName = ({ firstName, lastName, email }: FullNameSource): string => {
  if (firstName) {
    return `${firstName} ${lastName ?? ''}`;
  }
  return email ?? '';
};

export default toFullName;
